import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue,formValueSelector, reduxForm, Field} from 'redux-form';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import {
    renderFieldSelect
} from '../../util/inputs';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import bloquerItinerarioPorCidadeEmLote from '../../actions/itinerario/bloquerItinerarioPorCidadeEmLote';
import {showSuccessMsg} from '../../util/messagesUtil';
import DiasSemanaSelector from './DiasSemanaSelector';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

class ModalBloquearItinerarioPorCidadeEmLote extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);          
        this.state = {
            dataInicio: null, dataFim: null, cidadesSelecionadasEmLote: [], diasSelecionados: []
        }
    }
     
    
    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }

        
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    montarParametroItinerario() {        
        return {
            dataInicio: moment(this.state.dataInicio).format('DD/MM/YYYY'),
            dataFim: moment(this.state.dataFim).format('DD/MM/YYYY'),            
            empresaId: this.props.empresaSelecionada.id,
            rotaId: this.props.rotaSelecionada.value,
            diasSelecionados: this.state.diasSelecionados ? this.state.diasSelecionados: [],
            cidadesBloqueadasEmLote: this.state.cidadesSelecionadasEmLote.map(it => (
                {idCidade: it.value}
            )),
        }
    }

    submit() {  
        
        const parametros = this.montarParametroItinerario()        
        this.props.bloquerItinerarioPorCidadeEmLote(parametros) 
        .then(() => {
            showSuccessMsg('Bloqueios realizado com sucesso');
            this.fecharModal();
            this.props.buscarItinerarios();
        })     
    }

    recuperarTrechos() {
        if (this.props.rotas && this.props.rotaSelecionada) {
            return this.props.trechos.sort((n1, n2) => {
                if (n1.ordem > n2.ordem) {
                    return 1;
                }

                if (n1.ordem < n2.ordem) {
                    return -1;
                }

                return 0;
            });
        }
        return []
    }

    removerCidadeSelecionadaEmLote(idCidade){
        this.setState({cidadesSelecionadasEmLote: this.state.cidadesSelecionadasEmLote.filter(it => !(it.value === idCidade))})
    }

    adicionarCidade(event){       
        event.preventDefault();        
        const cidade = this.props.cidade;   
        
        if(this.state.cidadesSelecionadasEmLote.filter(it => it.value === cidade.value).length ===  0){
          
            const cidadesSelecionadasEmLote = this.state.cidadesSelecionadasEmLote;
            cidadesSelecionadasEmLote.push(cidade);
            this.setState({cidadesSelecionadasEmLote: cidadesSelecionadasEmLote})
        }
        this.props.changeFieldValue('formularioBloquearCidadesEmLote',
        'cidade', null);
    }

    fecharModal() {
        $('#modalBloquearItinerarioPorCidadeEmLote')
            .modal('hide');
        $('#modalBloquearItinerarioPorCidadeEmLote')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
//        this.props.reset('formularioBloquearCidadesEmLote');
        this.setState({dataInicio: null, dataFim: null, diasSelecionados: [], cidadesSelecionadasEmLote: []});
    }


    exibirCidadesSelecionadas() {        
        return (
            <table className="table table-sm table-bordered">
            <thead>
            <tr className='text-center'>
                <th colSpan='3'>Cidades Bloqueadas</th>
            </tr>
            <tr>
                <th>Cidade</th>               
                <th/>
            </tr>
            </thead>
            <tbody>
            {!this.state.cidadesSelecionadasEmLote || this.state.cidadesSelecionadasEmLote.length === 0 ?
                <tr className="alert alert-warning text-center mt-4" role="alert">
                    <td colSpan='3'>Nenhuma cidade foi
                        bloqueada.
                    </td>
                </tr>
                :
                this.state.cidadesSelecionadasEmLote
                    .map((cidade,i) => <tr key={i}>
                        <td>
                            {cidade.label}
                        </td>                       
                        <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                            <div
                                onClick={() => this.removerCidadeSelecionadaEmLote(cidade.value)}>Remover
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        )
        
    }
          
    
    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        const trechos = this.recuperarTrechos(); 
        
        return (            
            <>
                <form onSubmit={handleSubmit(this.submit)}>
                    <fieldset className="scheduler-border">
                        <div className="col-12 col-sm-4 col-md-4 mt-2">
                              <label>Opera em quais dias da semana?</label>
                              <DiasSemanaSelector
                                diasSelecionados={this.state.diasSelecionados}
                                onChange={(novosDias) => this.setState({ diasSelecionados: novosDias })}
                              />
                        </div>
                    </fieldset>
                    <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Informações básicas</legend>                       
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Quando começa?</label>
                            {this.exibirCalendario(true)}
                        </div>
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Quando encerra?</label>
                            {this.exibirCalendario()}
                        </div>                                                
                                              
                    </fieldset> 
                    <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Bloqueio de venda por cidades</legend>
                        <div className="col-12 col-sm-9 col-md-5">
                            <Field name="cidade"
                                    options={trechos.map(elemento => ({
                                    descricao: elemento.cidadeDestino.nome,
                                    nome: elemento.cidadeDestino.id
                                }))}
                                    component={renderFieldSelect}
                                    placeholder='Selecione a cidade'/>                                               
                        </div>                                    
                        <div className="col-12 col-sm-3 col-md-1">
                            <button disabled={!this.props.cidade}
                                    type="submit" className="btn btn-sm btn-laranja"
                                    onClick={(e) => this.adicionarCidade(e)}>Incluir
                            </button>
                        </div>
                        <div className="col-12 col-sm-12 col-md-10 mt-2">
                            <div className="lista-table">
                                {this.exibirCidadesSelecionadas()}
                            </div>
                        </div>
                    </fieldset>
                                                
                    <div className="modal-footer">
                        <button type="submit" 
                             disabled={invalid || submitting || !this.state.dataInicio
                                || !this.state.dataFim || !this.state.cidadesSelecionadasEmLote.length}
                            className="btn btn-laranja">Salvar</button>
                    </div>
                </form>
            </>
        );
    }

    render() {
        return (
            <div className="modal fade show" id='modalBloquearItinerarioPorCidadeEmLote' role='dialog'
                 aria-labelledby='modalBloquearItinerarioPorCidadeEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Bloquear cidades em lote</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,        
        rotas: state.rotas.rotas,
        rotaSelecionada: state.rotaSelecionada,
        trechos: state.trechos,
        cidade: formValueSelector('formularioBloquearCidadesEmLote')(state, 'cidade'),
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({                
       changeFieldValue,
       bloquerItinerarioPorCidadeEmLote
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioBloquearCidadesEmLote',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalBloquearItinerarioPorCidadeEmLote));


